"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluralize = void 0;
function pluralize(numeric, titles, didNotSaveNumeric) {
    var numericUpToHundred = Math.abs(numeric) % 100;
    var numericUpToTen = Math.abs(numeric) % 10;
    var text = didNotSaveNumeric ? '' : "".concat(String(numeric), " ");
    var cases = [2, 0, 1, 1, 1, 2];
    if ((numericUpToHundred > 4 && numericUpToHundred < 20)
        || numericUpToTen >= 5) {
        return text + titles[2];
    }
    return text + titles[cases[numericUpToTen]];
}
exports.pluralize = pluralize;
//# sourceMappingURL=pluralize.js.map